export default __webpack_public_path__ + "static/media/tick.cb650abb.svg";